var initialState = {
  testValue: 45
};

var testReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default testReducer;
